import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { BehaviorSubject, debounce, merge, timer } from 'rxjs';
import { RichFormControlDirective } from './rich-form-control.directive';

@Directive({
    selector: '[appHasError]',
    exportAs: 'appHasError',
})
export class HasErrorDirective implements OnInit {
    private readonly element = inject(ElementRef);
    private readonly hasErrorController = inject(HasErrorDirective, { optional: true, host: true, skipSelf: true });

    public invalid = true;
    private ngControls: RichFormControlDirective[] = [];
    private validationSubject = new BehaviorSubject<boolean>(true);

    ngOnInit(): void {
        this.validationSubject.pipe(debounce(() => timer(100))).subscribe((valid) => {
            this.invalid = !valid;
            if (valid) {
                this.element.nativeElement.classList.remove('has-error');
            } else {
                this.element.nativeElement.classList.add('has-error');
            }
        });
    }

    public registerNgControl(ngControl: RichFormControlDirective): () => void {
        this.ngControls.push(ngControl);

        this.checkErrors();

        const subscription = merge(
            ngControl.control.valueChanges,
            ngControl.control.statusChanges,
            ngControl.touched$
        ).subscribe(() => {
            this.checkErrors();
        });

        let parentUnsubscriber = () => {};
        if (this.hasErrorController) {
            parentUnsubscriber = this.hasErrorController.registerNgControl(ngControl);
        }

        return () => {
            parentUnsubscriber();
            subscription.unsubscribe();
            this.ngControls = this.ngControls.filter((control) => control !== ngControl);
            this.checkErrors();
        };
    }

    private checkErrors() {
        const validStatus = this.ngControls
            .map(({ control }) => control.disabled || control.valid || control.untouched)
            .reduce((acc, curr) => acc && curr, true); // AND operation

        this.validationSubject.next(validStatus);
    }
}
